module.exports = __webpack_public_path__ + "site/img/index12en.44dc5aa6.png";